import statistic from './statistic'

export default {
  settings: {
    isTimerDisabled: true,
    resetScoreOnPeriodChange: true,
    scoreInPoints: true,
    needToShowSets: true
  },
  actionTypes: {
    score: ['POINT', 'POINT_ACE', 'POINT_WINNER', 'DOUBLE_FAULT', 'UNFORCED_ERROR'],
    set: ['GAME', 'ADJUST_GAMES'],
    additionalScore: ['SET']
  },
  modules: {
    info: [],
    score: {
      component: 'tennis-score-component'
    },
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: {
      additionalPeriods: [{
        type: 'score',
        component: 'event-log-score',
        adjustEvents: ['ADJUST_GAMES']
      }]
    }
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    sets: {
      home: 0,
      away: 0
    },
    additionalScore: {
      home: 0,
      away: 0
    }
  }
}
